import { defineStore } from 'pinia'

import api from '@/api/member.js'

const UNAUTHROIZED_CODE = 401
const NOT_FOUND_CODE = 404
export const useMemberStore = defineStore('member', {
  state: () => ({
    member: {
      init: true
    },
    getMemberError: null,
    isRegister: false
  }),
  actions: {
    getMember ({ success, fail }) {
      api.getMember()
        .then(response => {
          this.member = response.body.data
          success?.(response)
        })
        .catch(error => {
          this.getMemberError = error
          fail?.(error)
        })
    },
    createMember ({ body, success, fail }) {
      api.createMember(body)
        .then(response => success && success(response))
        .catch(error => fail?.(error))
    },
    changeRegisterStatus (flag) {
      this.isRegister = flag
    },
    markOnboardingCompleted () {
      return api.markOnboardingCompleted().then(() => {
        this.member.uapOnboardingCompleted = true
      })
    }
  },
  getters: {
    isNotLoggedIn () {
      return this.getMemberError?.code === UNAUTHROIZED_CODE
    },
    isNotAffiliator () {
      return this.getMemberError?.code === NOT_FOUND_CODE
    }
  }
})
